import { Action } from 'redux';
import { Favorite } from '../entities';

export enum TFavorite {
  FAVORITE_ADD = 'FAVORITE_ADD',
  FAVORITE_REMOVE = 'FAVORITE_REMOVE',
  SET_FAVORITES = 'SET_FAVORITES',
  FETCH_FAVORITES = 'FETCH_FAVORITES'
}

export interface ISetFavorites extends Action {
  type: TFavorite.SET_FAVORITES;
  payload: Favorite[];
}
export const ASetFavorites = (payload: Favorite[]): ISetFavorites => ({ type: TFavorite.SET_FAVORITES, payload });

export interface IFavoriteAdd extends Action {
  type: TFavorite.FAVORITE_ADD;
  payload: { id: string };
}
export const AFavoriteAdd = (payload: { id: string }): IFavoriteAdd => ({ type: TFavorite.FAVORITE_ADD, payload });

export interface IFavoriteRemove extends Action {
  type: TFavorite.FAVORITE_REMOVE;
  payload: string;
}
export const AFavoriteRemove = (payload: string): IFavoriteRemove => ({ type: TFavorite.FAVORITE_REMOVE, payload });

export interface IFetchFavorites extends Action {
  type: TFavorite.FETCH_FAVORITES;
}
export const AFetchFavorites = (): IFetchFavorites => ({ type: TFavorite.FETCH_FAVORITES });
